export function getFormatter() {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    return function (value) {
        if (!value) {
            value = 0;
        }
        return formatter.format(value);
    };
}
export function downloadPdf(params) {
    return httpRequest(params)
        .then(response => {
        console.log('response downloadPdf:', response);
        console.log('response downloadPdf Content-Type:', response.headers.get("Content-Type"));
        if (response.ok && response.headers.get("Content-Type") === 'application/pdf') {
            return pdfSuccess(response);
        }
        else {
            return response.json();
        }
    });
}
function pdfSuccess(response) {
    const disposition = response.headers.get('Content-Disposition');
    let filename = '';
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    return response.blob().then(file => {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = decodeURI(filename);
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
    });
}
export function httpRequest(params) {
    const options = {
        method: params.method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken')
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(params.data)
    };
    if (!params.url) {
        params.url = location.pathname;
    }
    const url = new URL(params.url, location.origin);
    if (params.method.toLowerCase() === 'get') {
        delete options.body;
        url.search = new URLSearchParams(params.data).toString();
        if (params.pushState) {
            history.pushState({}, '', url);
        }
    }
    // @ts-ignore
    return fetch(url, options);
}
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
function submitData(data, method, url, pushState) {
    if (!url) {
        url = location.pathname;
    }
    return httpRequest({ method, data, url, pushState: pushState || false })
        .then(res => {
        if (res.status === 500) {
            res.blob().then(blob => {
                window.open(URL.createObjectURL(blob));
            });
        }
        else if (res.status >= 400) {
            res.json().then((data) => {
                if (data.message) {
                    alert(data.message);
                }
                else {
                    alert('Error en el formulario');
                }
            });
        }
        else if (res.redirected) {
            window.location.href = res.url;
        }
        else {
            return res.json();
        }
    });
}
export function debounce(func, wait, immediate = null) {
    let timeout;
    return function executedFunction() {
        const context = this;
        const args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
